import Button from '@doordash/component-button'
import { Stack, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { SupplyAcquisitionMethods } from '../../../constants'
import * as events from '../../../events'
import t from './strings'

type SupplyAcquisitionMethodSelectorProps = {
  setSupplyAcquisitionMethod?: any
  disableDropshipping?: any
  trackDropshippingEvent?: (eventType: string) => Promise<any>
}

export const SupplyAcquisitionMethodSelector: React.FC<SupplyAcquisitionMethodSelectorProps> = ({
  setSupplyAcquisitionMethod,
  disableDropshipping,
  trackDropshippingEvent,
}) => {
  React.useEffect(() => {
    trackDropshippingEvent('DA_dxds_selection_page')
  }, [trackDropshippingEvent])

  return (
    <div>
      <Stack>
        <Text styles={Text.Styles.Bold24}>{t.h1()}</Text>
      </Stack>
      <Stack>
        <StackChildren>
          <Text>{t.shipToMeText()}</Text>
          <Button
            accessibilityDescribedBy={'shipToMe'}
            onClick={() => {
              trackDropshippingEvent('DA_dxds_selection_page_dxds_selected')
              setSupplyAcquisitionMethod(SupplyAcquisitionMethods.DROPSHIPPING)
            }}
          >
            {t.shipToMeButton()}
          </Button>
          <Text color={Text.Colors.TextTertiary}>{t.instructionOne()}</Text>
          <Text color={Text.Colors.TextTertiary}>{t.instructionTwo()}</Text>
        </StackChildren>
      </Stack>

      <Stack>
        <Text>{t.or().toUpperCase()}</Text>
      </Stack>

      <StackChildren>
        <Text>{t.pickUpText()}</Text>
        <Button
          accessibilityDescribedBy={'pickItUp'}
          onClick={() => {
            trackDropshippingEvent('DA_dxds_selection_page_scheduled_selected')
            disableDropshipping()
            setSupplyAcquisitionMethod(SupplyAcquisitionMethods.GO_INTO_OFFICE)
          }}
        >
          {t.pickUpButton()}
        </Button>
        <Text color={Text.Colors.TextTertiary}>{t.instructionThree()}</Text>
      </StackChildren>
    </div>
  )
}

SupplyAcquisitionMethodSelector.defaultProps = {
  setSupplyAcquisitionMethod: console.log,
  disableDropshipping: console.log,
  trackDropshippingEvent: (aString: string) =>
    Promise.resolve(console.log(aString)),
}

const mapDispatchToProps = {
  trackDropshippingEvent: events.trackDropshippingEvent,
}

export const DisconnectedSupplyAcquisitionMethodSelector = SupplyAcquisitionMethodSelector

export default connect(
  null,
  mapDispatchToProps
)(SupplyAcquisitionMethodSelector)
